import React, { FC } from 'react'
import Title from 'antd/lib/typography/Title'
import { Page } from '../../components'
import styles from './index.module.less'

const H2: FC = ({ children }) => (
	<Title className={styles.termSubheader} level={2}>
		{children}
	</Title>
)

const Terms: FC = () => (
	<div style={{ maxWidth: '900px', margin: 'auto' }}>
		<Page title='Mondago Licensing Portal Terms of Use'>
			<p>Please Read These Terms and Conditions Carefully Before Using this Portal</p>
			<H2>What is in These Terms?</H2>
			<p>
				These terms tell you the rules for using our portal <a href='https://licensing-portal.mondago.com'>https://licensing-portal.mondago.com</a>{' '}
				(&quot;our portal&quot;).
			</p>
			<H2>Who We Are and How to Contact Us</H2>
			<p>
				<a href='https://licensing-portal.mondago.com'>https://licensing-portal.mondago.com</a> is a portal operated by the Mondago group of companies
				(&quot;We&quot;).
			</p>
			<p>
				To contact us please go to the web-site at: <a href='https://www.mondago.com/contact-us/'>https://www.mondago.com/contact-us/</a>
			</p>
			<H2>By Using Our Portal You Accept These Terms</H2>
			<p>By using our portal, you confirm that you accept these terms of use and that you agree to comply with them.</p>
			<p>If you do not agree to these terms, you must not use our portal.</p>
			<p>
				You are also responsible for ensuring that all persons who access our portal through your internet connection are aware of these terms of use
				and other applicable terms and conditions, and that they comply with them.
			</p>
			<p>We recommend that you print a copy of these terms for future reference.</p>
			<H2>There Are Other Terms That May Apply to You</H2>
			<p>These terms of use refer to the following additional terms, which also apply to your use of our portal:</p>
			<ul>
				<li>
					our Privacy Policy <a href='https://www.mondago.com/policies/?privacy-policy'>https://www.mondago.com/policies/?privacy-policy</a>.
				</li>
				<li>the contract you/your organisation entered into to secure your access to our portal (&quot;your contract&quot;); and</li>
				<li>
					if you order software/services from our portal, additional terms and conditions will apply to the orders as determined by your contract.
				</li>
			</ul>
			<H2>We May Make Changes to These Terms</H2>
			<p>
				We amend these terms from time to time. Every time you wish to use our portal, please check these terms and those referred to above to ensure
				you understand the terms that apply at that time. These terms were most recently updated on 22nd December 2020
			</p>
			<H2>We May Make Changes to Our Portal</H2>
			<p>We may update and change our portal from time to time to reflect changes to our products, our users&apos; needs and our business priorities.</p>
			<H2>We May Suspend or Withdraw Our Portal</H2>
			<p>
				We do not guarantee that our portal, or any content on it, will always be available or be uninterrupted. We may suspend or withdraw or restrict
				the availability of all or any part of our portal for business and operational reasons. We will try to give you reasonable notice of any
				suspension or withdrawal.
			</p>
			<H2>We May Transfer this Agreement to Someone Else</H2>
			<p>
				We may transfer our rights and obligations under these terms to another organisation. We will always tell you in writing if this happens and we
				will ensure that the transfer will not affect your rights under the contract.
			</p>
			<H2>You Must Keep Your Account Details Safe</H2>
			<p>
				If you choose, or you are provided with, a user identification, password, or any other piece of information as part of our security procedures,
				you must treat such information as confidential. You must not disclose it to any third party.
			</p>
			<p>
				We have the right to disable any user identification or password, whether chosen by you or allocated by us, at any time, if in our reasonable
				opinion you have failed to comply with any of the provisions of these terms of use.
			</p>
			<p>
				If you know or suspect that anyone other than you knows your user identification or password, you must promptly notify us at info@mondago.com.
			</p>
			<H2>How You May Use Material on Our Portal</H2>
			<p>
				We are the owner or the licensee of all intellectual property rights in our portal, and in the material published on it. Those works are
				protected by copyright laws and treaties around the world. All such rights are reserved.
			</p>
			<p>
				You may print off one copy, and may download extracts, of any page&#123;s&#125; from our portal for your personal use and you may draw the
				attention of others within your organisation to content posted on our portal.
			</p>
			<p>
				You must not modify the paper or digital copies of any materials you have printed off or downloaded in any way, and you must not use any
				illustrations, photographs, video or audio sequences or any graphics separately from any accompanying text.
			</p>
			<p>Our status &#123;and that of any identified contributors&#125; as the authors of content on our portal must always be acknowledged.</p>
			<p>
				You have been provided with access to our portal for the primary purpose of using it to manage licences for our software. You must not use any
				part of the content on our portal for any other purposes without obtaining consent to do so from us or our approved partners.
			</p>
			<p>
				If you print off, copy or download any part of our portal in breach of these terms of use, your right to use our portal will cease immediately
				and you must, at our option, return or destroy any copies of the materials you have made.
			</p>
			<H2>Do Not Rely on Information on this Portal</H2>
			<p>
				The content on our portal is not intended to amount to advice on which you should rely. You must obtain professional or specialist advice before
				taking, or refraining from, any action on the basis of the content on our portal.
			</p>
			<p>
				Although we make reasonable efforts to update the information on our portal, we make no representations, warranties or guarantees, whether
				express or implied, that the content on our portal is accurate, complete or up to date.
			</p>
			<H2>We Are Not Responsible for Websites We Link To</H2>
			<p>
				Where our portal contains links to websites and resources provided by third parties, these links are provided for your information only. Such
				links should not be interpreted as approval by us of those linked websites or information you may obtain from them.
			</p>
			<p>We have no control over the contents of those websites or resources.</p>
			<H2>Our Responsibility for Loss or Damage Suffered By You</H2>
			<ul>
				<li>
					We do not exclude or limit in any way our liability to you where it would be unlawful to do so. This includes liability for death or
					personal injury caused by our negligence or the negligence of our employees, agents or subcontractors and for fraud or fraudulent
					misrepresentation.
				</li>
				<li>
					Different limitations and exclusions of liability will apply to liability arising as a result of the supply to you of any software/services,
					which will be set out in your contract.
				</li>
				<li>We exclude all implied conditions, warranties, representations or other terms that may apply to our portal or any content on it.</li>
				<li>
					We will not be liable to you for any loss or damage, whether in contract, tort &#123;including negligence&#125;, breach of statutory duty,
					or otherwise, even if foreseeable, arising under or in connection with:
					<ul>
						<li>use of, or inability to use, our portal; or</li>
						<li>use of or reliance on any content displayed on our portal.</li>
					</ul>
				</li>
				<li>
					In particular, we will not be liable for:
					<ul>
						<li>loss of profits, sales, business, or revenue;</li>
						<li>business interruption;</li>
						<li>loss of anticipated savings;</li>
						<li>loss of business opportunity, goodwill or reputation; or</li>
						<li>any indirect or consequential loss or damage.</li>
					</ul>
				</li>
			</ul>
			<H2>How We May Use Your Personal Information</H2>
			<p>
				We will only use your personal information as set out in our Privacy Policy{' '}
				<a href='https://www.mondago.com/policies/?privacy-policy'>https://www.mondago.com/policies/?privacy-policy.</a>
			</p>
			<H2>Uploading Content to Our Portal</H2>
			<p>
				Whenever you make use of a feature that allows you to upload content to our portal, or to make contact with other users of our portal, you must
				do so in compliance with all applicable laws and standards.
			</p>
			<p>
				You warrant that any such contribution does comply with those laws and standards, and you will be liable to us and indemnify us for any breach
				of that warranty. This means you will be responsible for any loss or damage we suffer as a result of your breach of warranty.
			</p>
			<p>
				Any content you upload to our portal will be considered non-confidential and non-proprietary. You retain all of your ownership rights in your
				content, but you are required to grant us and other users of our portal a limited licence to use, store and copy that content and to distribute
				and make it available to third parties.
			</p>
			<p>
				We also have the right to disclose your identity to any third party who is claiming that any content posted or uploaded by you to our portal
				constitutes a violation of their intellectual property rights, or of their right to privacy.
			</p>
			<p>We have the right to remove any posting you make on our portal if, in our opinion, your post does not comply with these terms.</p>
			<p>You are solely responsible for securing and backing up your content.</p>
			<H2>We Are Not Responsible for Viruses and You Must Not Introduce Them</H2>
			<p>We do not guarantee that our portal will be secure or free from bugs or viruses.</p>
			<p>
				You are responsible for configuring your information technology, computer programmes and platform to access our portal. You should use your own
				virus protection software.
			</p>
			<p>
				You must not misuse our portal by knowingly introducing viruses, trojans, worms, logic bombs or other material that is malicious or
				technologically harmful. You must not attempt to gain unauthorised access to our portal, the server on which our portal is stored or any server,
				computer or database connected to our portal. You must not attack our portal via a denial-of-service attack or a distributed denial-of service
				attack. By breaching this provision, you would commit a criminal offence under the Computer Misuse Act 1990. We will report any such breach to
				the relevant law enforcement authorities and we will co-operate with those authorities by disclosing your identity to them. In the event of such
				a breach, your right to use our portal will cease immediately.
			</p>
			<H2>Rules About Linking to Our Portal</H2>
			<p>You may link to our home page, provided you do so in a way that is fair and legal and does not damage our reputation or take advantage of it.</p>
			<p>You must not establish a link in such a way as to suggest any form of association, approval or endorsement on our part where none exists.</p>
			<p>You must not establish a link to our portal in any website that is not owned by you.</p>
			<p>Our portal must not be framed on any other portal, nor may you create a link to any part of our portal other than the home page.</p>
			<H2>We reserve the right to withdraw linking permission without notice.</H2>
			<p>The website in which you are linking must comply in all respects with applicable laws and standards.</p>
			<p>If you wish to link to or make any use of content on our portal other than that set out above, please contact info@mondago.com.</p>
			<H2>Trade Marks</H2>
			<p>
				You are not permitted to use any of our trade marks without our approval, unless they are part of material you are using as permitted under How
				you may use material on our portal.
			</p>
			<H2>Which Country&apos;s Laws Apply to Any Disputes?</H2>
			<p>
				These terms of use, their subject matter and their formation &#123;(and any non-contractual disputes or claims&#125; are governed by English
				law. We both agree to the exclusive jurisdiction of the courts of England and Wales.
			</p>
		</Page>
	</div>
)

export default Terms
